import { render } from "./InputTextNewTheme.vue?vue&type=template&id=97eff58e&scoped=true"
import script from "./InputTextNewTheme.vue?vue&type=script&lang=js"
export * from "./InputTextNewTheme.vue?vue&type=script&lang=js"

import "./InputTextNewTheme.vue?vue&type=style&index=0&id=97eff58e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97eff58e"]])

export default __exports__